import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-container" style={{paddingTop: '5rem'}}>
      <div className="privacy-content">
        {/* Header */}
        <div className="privacy-header">
          <h1>{t('privacy.title')}</h1>
          <p className="privacy-date">{t('privacy.lastUpdated')}: {t('privacy.date')}</p>
        </div>

        {/* Welcome Section */}
        <section className="privacy-section">
          <p className="privacy-intro">{t('privacy.welcome')}</p>
        </section>

        {/* 1. Information We Collect */}
        <section className="privacy-section">
          <h2>{t('privacy.section1.title')}</h2>
          <p>{t('privacy.section1.content1')}</p>
          <h3>{t('privacy.section1.subtitle1')}</h3>
          <ul>
            <li>{t('privacy.section1.item1')}</li>
            <li>{t('privacy.section1.item2')}</li>
            <li>{t('privacy.section1.item3')}</li>
            <li>{t('privacy.section1.item4')}</li>
          </ul>
          <h3>{t('privacy.section1.subtitle2')}</h3>
          <ul>
            <li>{t('privacy.section1.item5')}</li>
            <li>{t('privacy.section1.item6')}</li>
            <li>{t('privacy.section1.item7')}</li>
          </ul>
        </section>

        {/* 2. How We Use Your Information */}
        <section className="privacy-section">
          <h2>{t('privacy.section2.title')}</h2>
          <p>{t('privacy.section2.content1')}</p>
          <ul>
            <li>{t('privacy.section2.item1')}</li>
            <li>{t('privacy.section2.item2')}</li>
            <li>{t('privacy.section2.item3')}</li>
            <li>{t('privacy.section2.item4')}</li>
            <li>{t('privacy.section2.item5')}</li>
          </ul>
        </section>

        {/* 3. Data Storage and Security */}
        <section className="privacy-section">
          <h2>{t('privacy.section3.title')}</h2>
          <p>{t('privacy.section3.content1')}</p>
          <p>{t('privacy.section3.content2')}</p>
          <p>{t('privacy.section3.content3')}</p>
        </section>

        {/* 4. Sharing Your Information */}
        <section className="privacy-section">
          <h2>{t('privacy.section4.title')}</h2>
          <p>{t('privacy.section4.content1')}</p>
          <ul>
            <li>{t('privacy.section4.item1')}</li>
            <li>{t('privacy.section4.item2')}</li>
            <li>{t('privacy.section4.item3')}</li>
          </ul>
          <p>{t('privacy.section4.content2')}</p>
        </section>

        {/* 5. Cookies and Tracking */}
        <section className="privacy-section">
          <h2>{t('privacy.section5.title')}</h2>
          <p>{t('privacy.section5.content1')}</p>
          <ul>
            <li>{t('privacy.section5.item1')}</li>
            <li>{t('privacy.section5.item2')}</li>
            <li>{t('privacy.section5.item3')}</li>
          </ul>
          <p>{t('privacy.section5.content2')}</p>
        </section>

        {/* 6. Your Rights */}
        <section className="privacy-section">
          <h2>{t('privacy.section6.title')}</h2>
          <p>{t('privacy.section6.content1')}</p>
          <ul>
            <li>{t('privacy.section6.item1')}</li>
            <li>{t('privacy.section6.item2')}</li>
            <li>{t('privacy.section6.item3')}</li>
            <li>{t('privacy.section6.item4')}</li>
            <li>{t('privacy.section6.item5')}</li>
          </ul>
          <p>{t('privacy.section6.content2')}</p>
        </section>

        {/* 7. Children's Privacy */}
        <section className="privacy-section">
          <h2>{t('privacy.section7.title')}</h2>
          <p>{t('privacy.section7.content1')}</p>
          <p>{t('privacy.section7.content2')}</p>
        </section>

        {/* 8. Third-Party Links */}
        <section className="privacy-section">
          <h2>{t('privacy.section8.title')}</h2>
          <p>{t('privacy.section8.content1')}</p>
          <p>{t('privacy.section8.content2')}</p>
        </section>

        {/* 9. Changes to Privacy Policy */}
        <section className="privacy-section">
          <h2>{t('privacy.section9.title')}</h2>
          <p>{t('privacy.section9.content1')}</p>
          <p>{t('privacy.section9.content2')}</p>
        </section>

        {/* 10. Contact Us */}
        <section className="privacy-section">
          <h2>{t('privacy.section10.title')}</h2>
          <p>{t('privacy.section10.content1')}</p>
          <div className="contact-info">
            <p><strong>{t('privacy.section10.email')}:</strong> store@beautypro.ge</p>
            <p><strong>{t('privacy.section10.phone')}:</strong> +995 577 188 177</p>
            <p><strong>{t('privacy.section10.address')}:</strong> {t('privacy.section10.addressValue')}</p>
          </div>
        </section>

        {/* Footer Note */}
        <div className="privacy-footer">
          <p>{t('privacy.footer')}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;